import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/branding.css'
import { initializeOfflineCache } from './lib/offline-cache'
import { ErrorBoundary } from './components/ErrorBoundary'

initializeOfflineCache().catch(console.error)

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

const missingVars = ['VITE_PRIVY_APP_ID'].filter(
  (key) => !import.meta.env[key]
)

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      {missingVars.length > 0 ? (
        <div style={{
          padding: '40px',
          color: '#fff',
          background: '#0C0819',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif'
        }}>
          <h1 style={{ color: '#f87171', marginBottom: '16px' }}>Configuration Error</h1>
          <p style={{ color: '#a1a1aa', marginBottom: '24px' }}>
            The app cannot start because required environment variables are missing:
          </p>
          <ul style={{
            background: '#110b21',
            padding: '20px 32px',
            borderRadius: '8px',
            listStyle: 'none',
            margin: 0
          }}>
            {missingVars.map((v) => (
              <li key={v} style={{ color: '#fbbf24', fontFamily: 'monospace', padding: '4px 0' }}>
                {v}
              </li>
            ))}
          </ul>
          <p style={{ color: '#71717a', marginTop: '24px', fontSize: '14px' }}>
            Add them to Vercel Environment Variables and redeploy.
          </p>
        </div>
      ) : (
        <App />
      )}
    </ErrorBoundary>
  </React.StrictMode>,
)
